import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authActions from "../actions/auth";
import * as shopActions from "../actions/shop";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./scss/Login.scss";

import loginBg from "../images/login/login-bg.png";
import eye_closed from "../images/login/eye_closed.png";
import eye_opened from "../images/login/eye_opened.png";

const Login = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);

  document.title = `Gudema - ${t("loginPage.title")}`;

  const submitHandler = async (e) => {
    e.preventDefault();

    const authResult = await props.auth(
      props.username,
      props.password
    );

    if (authResult) {
      history.push("/shop");
    }
  };

  return (
    <main className="login-page">
      <section className="login-card">
        <div className="login-card__form-side">
          <h1>{t("loginPage.title")}</h1>

          <p>{t("loginPage.subtitle")}</p>

          <form className="login-form" onSubmit={submitHandler}>
            <label>
              <input
                type="text"
                name="email"
                placeholder={t("loginPage.emailPlaceholder")}
                value={props.username || ""}
                onChange={props.onChangeName}
                required
              />
            </label>

            <label className="login-form__password">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder={t("loginPage.passwordPlaceholder")}
                value={props.password || ""}
                onChange={props.onChangePassword}
                required
              />

              <span onClick={() => setShowPassword(!showPassword)}>
                <img src={showPassword ? eye_opened : eye_closed} alt="hidden" />
              </span>
            </label>

            {props.alert ? (
              <div className="login-form__error">
                {t("loginPage.wrong")}
              </div>
            ) : null}

            

            <button type="submit">
              {t("loginPage.title")}
              <span>→</span>
            </button>
          </form>

          <div className="login-card__register">
            {t("loginPage.noAccount")} <Link to="/register">{t("loginPage.register")}</Link>
          </div>
        </div>

        <div className="login-card__image-side">
          <img src={loginBg} alt="" />

          <div className="login-card__image-text">
            <h2>{t("loginPage.imageTitle")}</h2>
            <p>{t("loginPage.imageText")}</p>
          </div>
        </div>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  username: state.auth.username,
  password: state.auth.password,
  alert: state.auth.alert,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(authActions, dispatch),
  ...bindActionCreators(shopActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
